/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import Stack from '@mui/material/Stack'
import Chip from '@mui/material/Chip'
import { Tooltip } from '@mui/material'
import * as classes from './styles'

const VISIBLE_CHIPS_COUNT = 4

type Item = { id: string; label: string }

type Props = {
  orderIds: string[]
  items: Item[]
}

export const SectionItem: FC<Props> = ({ orderIds, items }) => {
  const restCount = items.length - VISIBLE_CHIPS_COUNT

  const successStoryOrder =
    (orderIds
      .map((id) => items.find(({ id: successStoryId }) => id === successStoryId))
      .filter((successStory) => !!successStory) as Item[]) || []

  return (
    <Stack css={classes.stack} direction="row" spacing={1}>
      {successStoryOrder.slice(0, VISIBLE_CHIPS_COUNT).map(({ label }, i) => (
        <Tooltip key={i} title={label}>
          <Chip label={label} css={classes.chip} />
        </Tooltip>
      ))}
      {restCount > 0 && <Chip label={`+${restCount}`} css={classes.chip} />}
    </Stack>
  )
}
